<div class="invoice-upload-widget-body" [ngClass]="{'isHideUploadButtonHack': isIE11}">
  <div class="main-header">
    {{ getHeader() }}
  </div>
  <p-fileUpload #fileUploader name="files" accept="application/pdf"
                multiple="true"
                [invalidFileTypeMessageSummary]="invalidFileTypeMessage"
                [invalidFileTypeMessageDetail]="invalidFileTypeMessageDetail"
                [showCancelButton]="false"
                auto="true"
                chooseLabel="Upload"
                customUpload="true"
                (onError)="handleError($event)"
                (uploadHandler)="fileUploadEvent($event)"
                (onSelect)="onSelectEvent($event)">


    <ng-template let-file pTemplate="file">
    </ng-template>

    <ng-template pTemplate="toolbar">
      <div *ngIf="hasFiles()" class="footer-text">
        <span>
          The above invoices will not be passed to us for
          consideration until you provide details and send the document
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="invoice-upload-image">
        <div class="invoice-item-container">
            <mojo-invoice-upload-item
              *ngFor="let file of files" [file]="file"
              (click)="onItemClick($event)"
              (delete)="deleteFile($event)"></mojo-invoice-upload-item>
        </div>
      </div>
    </ng-template>

  </p-fileUpload>

</div>
